import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Button } from "@inmagik/magik-ui"
import { useMemo } from "react"
import type { Keyword } from "../../types"
import { initialValuesKeyword, validationSchemaKeyword } from "./KeywordCommon"
import KeywordForm from "./KeywordForm"

export default function KeywordModal({
  title,
  keyword,
  save,
  show,
  onClose,
}: {
  title: string
  keyword?: Keyword
  save: (values: Keyword, actions: { setErrors: (errors: any) => void }) => Promise<void>
  show: boolean
  onClose: () => void
}) {
  const initialValues = useMemo(() => initialValuesKeyword(keyword) as Keyword, [keyword])
  const validationSchema = useMemo(() => validationSchemaKeyword(), [])

  return (
    <Formik enableReinitialize initialValues={initialValues} validationSchema={validationSchema} onSubmit={save}>
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <KeywordForm col={12} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
